export default defineAppConfig({
  ui: {
    colors: {
      neutral: 'slate',
    },
    icons: {
      check: 'i-heroicons-check-16-solid',
      chevronUp: 'i-heroicons-chevron-up-solid',
      chevronDown: 'i-heroicons-chevron-down-solid',
      chevronLeft: 'i-heroicons-chevron-left-solid',
      chevronRight: 'i-heroicons-chevron-right-solid',
      chevronDoubleLeft: 'i-heroicons-chevron-double-left',
      chevronDoubleRight: 'i-heroicons-chevron-double-right',
      close: 'i-heroicons-x-mark-solid',
      loading: 'i-custom-logo',
      minus: 'i-heroicons-minus-16-solid',
      plus: 'i-heroicons-plus-16-solid',
      arrowLeft: 'i-heroicons-arrow-left-16-solid',
      arrowRight: 'i-heroicons-arrow-right-16-solid',
      ellipsis: 'i-heroicons-ellipsis-horizontal-16-solid',
      external: 'i-heroicons-arrow-up-right-16-solid',
      file: 'i-heroicons-document',
      folder: 'i-heroicons-folder',
      folderOpen: 'i-heroicons-folder-open',
      search: 'i-heroicons-magnifying-glass-16-solid',
      upload: 'i-heroicons-arrow-up-tray-16-solid',
    },
    button: {
      slots: {
        base: 'rounded-md disabled:text-muted font-medium',
      },
      variants: {
        variant: {
          link: 'cursor-pointer hover:underline focus-visible:ring-1 rounded-md',
        },
      },
    },
    checkbox: {
      slots: {
        base: 'focus:outline-primary focus:outline-2 focus:outline-offset-2',
      },
    },
    inputMenu: {
      slots: {
        base: 'rounded-md py-3! ring ring-accented disabled:bg-gray-100 disabled:text-dimmed text-base sm:text-sm focus:ring-2 focus:ring-cblack',
        item: 'data-highlighted:not-data-disabled:text-white data-highlighted:not-data-disabled:before:bg-primary/95',
        root: 'w-full',
      },
    },
    select: {
      slots: {
        base: 'py-3! w-full',
      },
    },
    inputNumber: {
      slots: {
        base: 'py-3!',
        root: 'w-full',
      },
    },
    input: {
      slots: {
        base: 'py-3!',
        root: 'w-full',
      },
    },
    textarea: {
      slots: {
        root: 'w-full',
        base: 'py-3! px-2.5!',
      },
    },
    link: {
      base: 'font-medium cursor-pointer hover:underline',
    },
    modal: {
      slots: {
        footer: 'flex items-center gap-1.5 p-4 sm:px-6 justify-end',
      },
    },
    table: {
      slots: {
        td: 'text-muted',
      },
    },
    toast: {
      slots: {
        icon: 'shrink-0 size-6',
      },
    },
  },
})
